export default __webpack_public_path__ + "static/media/deleted.38226ddd.svg";